<div class="flex items-center">
  <span class="no-employee-icon mr-[8px]">i</span>
  <span class="text-[13px] font-light">{{ 'bookingPage.scheduleAppointmentPage.noAvailableEmployeeTitle' | translate}}</span>
</div>
